import React from 'react';
import Routes from './routes/Routes';

// default theme
import './assets/scss/theme.scss';
function App() {
  return (
    <Routes></Routes>
  );
}

export default App;
